import { useDashboardDomainContext } from "../DashboardDomainProvider";
import DashboardHeader from '../components/DashboardHeader/DashboardHeader';
import { VisualGrid } from '../components/VisualGrid/VisualGrid';
import NavigationRibbon from '../components/NavigationRibbon/NavigationRibbon';
import { Loading } from "./Loading";
import './Dashboard.scss';
import DatasetPanel from "../components/DatasetPanel"
import { LoadingScreen } from "../components/LoadingScreen";
import { ErrorMessage } from "../components/VisualGrid/messages/ErrorMessage";
import { useState } from "react";

const Dashboard = () => {
  const { isDashboardLoading, dashboardLib } = useDashboardDomainContext();
  const hasError = !!dashboardLib?.hasError;
  const [datasetOpen, setDatasetOpen] = useState(false);
  const handelOnAction = ()=>{
    setDatasetOpen(!datasetOpen);
  }

  return (
    <div className="dashboard-container">
      <LoadingScreen isLoading={isDashboardLoading} fadeIn={false}>
        <Loading />
      </LoadingScreen>

      {hasError ? (
        <ErrorMessage />
      ) : (
        <>
          <DatasetPanel open={datasetOpen}  />
          <DashboardHeader onActionClicked={handelOnAction} />
          <VisualGrid />
          <NavigationRibbon />
        </>
      )}
    </div>
  );
};

export default Dashboard;
